
import { Button } from "@/components/ui/button";
import { goToHeroOrderForm } from '@/lib/utils';
import { Check } from "lucide-react";


const BookOfferSection = () => {
  
  
  const benefits = [
    "Double your income while working half the year",
    "Build your business network for consistent work",
    "Start funding your dreams with your extra income",
    "Position yourself as the go-to expert in your field",
    "Create systems to scale beyond trading time for money",
    "Optimize your business structure for maximum tax benefits"
  ];

  return (
    <section className="gradient-section">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-8">
          <div className="w-full lg:w-1/2 order-2 lg:order-1 lg:pl-8 xl:pl-16 lg:pr-4">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              A Secret Weapon For <br className="hidden md:block"/> 
               ERP Consultants
            </h2>
            
            <p className="text-lg mb-8">
              "The Liberated Consultant" reveals the exact framework I used to quit my corporate job, double my income, and build a thriving independent consulting business that allows me greater freedom in my work and life.
              -Rey Marques
            </p>
            
            <div className="space-y-3 mb-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Check className="h-5 w-5 text-book-orange" />
                  </div>
                  <p className="ml-3 text-book-darkBg">{benefit}</p>
                </div>
              ))}
            </div>
            
            <Button 
              onClick={goToHeroOrderForm}
              className="bg-book-yellow hover:bg-book-yellow/90 text-book-darkBlue font-bold py-3 px-6 text-base uppercase tracking-wide shadow-lg transition-all duration-300 rounded-md" 
              size="lg"
            >
              Rush Me A Free Copy
            </Button>
          </div>
          
          <div className="w-full lg:w-1/2 order-1 lg:order-2 flex justify-center">
            <img 
              src="/lovable-uploads/8dbfc0d9-7e83-4ac6-8e13-0b8ec0bf0fed.png" 
              alt="The Liberated Consultant Book" 
              className="h-96 object-contain drop-shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookOfferSection;
